import { FormlyFieldConfig } from "@ngx-formly/core";

export const AllegatiIntegrazioneStep: FormlyFieldConfig[] = [
    
        {
          "wrappers": ['top-panel'],
          props: {
              "label": "RIFERIMENTI PRATICA ESISTENTE",
          },
          "fieldGroup": [
              {
                  "fieldGroupClassName": 'grid grid-flow-row-dense sm:grid-cols-1 md:grid-cols-3 gap-4',
                  "fieldGroup": [
                      {
                          "className": 'xl:col-span-1 sm:col-span-1 md:col-span-1',
                          "key": 'jd.numero_protocollo_parent',
                          "type": 'mat-input',
                          "props": {
                              "label": 'PROTOCOLLO',
                          }
                      },
                      {
                          "className": 'xl:col-span-1 sm:col-span-1 md:col-span-1',
                          "key": 'jd.data_protocollo_parent',
                          "type": 'mat-datepicker',
                          "props": {
                              "label": 'DATA PROTOCOLLO',
                          }
                      },
                      {
                        "className": 'xl:col-span-1 sm:col-span-1 md:col-span-1',
                        "key": 'jd.intestatario_parent',
                        "type": 'mat-input',
                        "props": {
                            "label": 'INTESTATARIO',
                        }
                    },
                  ]
              },

          ],
      },
        {
            "key": 'jd.integrazione_descrizione',
            "type":'mat-textarea',
            "props": {
                "label": "SPECIFICARE LE MODIFICHE/INTEGRAZIONI EFFETTUATE",
                "autosize": true,
                "required": true,
                "autosizeMaxRows": 4,
                "autosizeMinRows": 2,
                "description": "Specificare puntualmente le modifiche/integrazioni effettuate"
            },
            "validation":{
                "show":true
            },
        },
        {
            key: 'allegati_documentazione_altro',
            type: 'mat-upload',
            props: {
              label: "DOCUMENTAZIONE ALLEGATA",
              multiple: true,
              required:true
            }
          },
      ]
